import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalId,
  zodOptionalString,
  zodPage,
  zodPathParamId,
  zodSort,
} from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyKopilotInvoicesRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/kopilot/invoices',
  validateSearch: z.object({
    page: zodPage,
    query: zodOptionalString,
    tab: z.enum(['invoices', 'avoirs', 'commandes', 'lignes']).default('invoices'),
    labId: zodOptionalId,
    // Invoices tab params
    invoicesSort: zodSort([
      'invoice_date',
      'invoice_number',
      'total_amount',
      'claim_amount',
      'supplier',
    ]),
    invoicesQuery: zodOptionalString,
    invoicesVerificationStatus: z
      .enum([
        'all',
        'to_be_verified',
        'ongoing',
        'none',
        'not_received',
        'ignored',
        'auto_verified',
        'verified_closed',
      ])
      .default('to_be_verified'),
    invoicesDateFrom: z.string().optional(),
    invoicesDateTo: z.string().optional(),
    // Avoirs tab params
    avoirsQuery: zodOptionalString,
    avoirsVerificationStatus: z
      .enum([
        'all',
        'to_be_verified',
        'ongoing',
        'none',
        'not_received',
        'ignored',
        'auto_verified',
        'verified_closed',
      ])
      .optional(),
    avoirsDateFrom: z.string().optional(),
    avoirsDateTo: z.string().optional(),
    // Commandes (LGO Orders) tab params
    commandesPage: zodPage,
    commandesQuery: zodOptionalString,
    commandesDateFrom: z.string().optional(),
    commandesDateTo: z.string().optional(),
    commandesIncludeWholesalers: z.boolean().optional(),
    // Lignes (Line Items) tab params
    lignesPage: zodPage,
    lignesQuery: zodOptionalString,
    lignesDateFrom: z.string().optional(),
    lignesDateTo: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/pharmacy/KopilotInvoices/PharmacyKopilotInvoicesPage').then((d) => d.Route)
);

export const pharmacyKopilotInvoiceDetailRoute = createRoute({
  getParentRoute: () => pharmacyKopilotInvoicesRoute,
  path: '/$invoiceId',
  params: z.object({ invoiceId: zodPathParamId }),
}).lazy(() =>
  import('pages/pharmacy/KopilotInvoices/PharmacyKopilotInvoicePanel').then((d) => d.Route)
);
